import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../Utils/BaseUrl";
import { useNavigate } from "react-router-dom";
const ProfileTabs = () => {

  const [activeTab, setActiveTab] = useState("about");
  const [about, setAbout] = useState({});
  const [posts, setPosts] = useState([]);
  const [form, setForm] = useState({});
  const [isEditing, setIsEditing] = useState(false);
const [selectedPost, setSelectedPost] = useState(null);
  const user_id = localStorage.getItem("user_id");
const navigate = useNavigate();
  /* ================= FETCH PROFILE ================= */

  const getAbout = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/profile_about`, { user_id });

      setAbout(res.data || {});
      setForm(res.data || {});

    } catch (err) {
      console.log(err);
    }
  };

  /* ================= FETCH POSTS ================= */

  const getPosts = async () => {

    try {

      const res = await axios.post(`${BASE_URL}/my_posts`, { user_id });

      const data = res.data.result;

      const postsArray = Array.isArray(data) ? data : Object.values(data);

      setPosts(postsArray);

    } catch (err) {
      console.log(err);
    }

  };

  useEffect(() => {

    if (activeTab === "about") getAbout();
    if (activeTab === "posts") getPosts();

  }, [activeTab]);

  /* ================= INPUT CHANGE ================= */

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  /* ================= UPDATE PROFILE ================= */

  const updateProfile = async () => {

    try {

      const payload = {
        user_id,
        ...form
      };

      await axios.post(`${BASE_URL}/update_profile`, payload);

      alert("Profile Updated Successfully");

      setIsEditing(false);

      getAbout();

    } catch (err) {

      console.log(err);

    }

  };

  return (

    <div className="main-ws-sec">

      {/* ================= TABS ================= */}

      <ul className="nav nav-tabs mb-3">

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "about" ? "active" : ""}`}
            onClick={() => setActiveTab("about")}
          >
            About
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "posts" ? "active" : ""}`}
            onClick={() => setActiveTab("posts")}
          >
            My Posts
          </button>
        </li>

      </ul>

      {/* ================= ABOUT TAB ================= */}

      {activeTab === "about" && (

        <div className="card p-4">

          <div className="d-flex justify-content-between mb-3">

            <h5>Profile Details</h5>

            {!isEditing ? (

              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setIsEditing(true)}
              >
                Edit Profile
              </button>

            ) : (

              <div>

                <button
                  className="btn btn-success btn-sm me-2"
                  onClick={updateProfile}
                >
                  Save
                </button>

                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setIsEditing(false);
                    setForm(about);
                  }}
                >
                  Cancel
                </button>

              </div>

            )}

          </div>

          <div className="row g-3">

            {/* First Name */}
            <div className="col-md-6">
              <label>First Name</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="firstname"
                  value={form.firstname || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.firstname || "-"}</p>
              )}
            </div>

            {/* Last Name */}
            <div className="col-md-6">
              <label>Last Name</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="lastname"
                  value={form.lastname || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.lastname || "-"}</p>
              )}
            </div>

            {/* Organization */}
            <div className="col-md-6">
              <label>Organization</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="orgname"
                  value={form.orgname || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.orgname || "-"}</p>
              )}
            </div>

            {/* Designation */}
            <div className="col-md-6">
              <label>Designation</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="designation"
                  value={form.designation || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.designation || "-"}</p>
              )}
            </div>

            {/* Mobile */}
            <div className="col-md-6">
              <label>Mobile</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="mobile"
                  value={form.mobile || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.mobile || "-"}</p>
              )}
            </div>

            {/* Birth Year */}
            <div className="col-md-6">
              <label>Birth Year</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="birthyear"
                  value={form.birthyear || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.birthyear || "-"}</p>
              )}
            </div>

            {/* Gender */}
            <div className="col-md-6">
              <label>Gender</label>
              {isEditing ? (
                <select
                  className="form-select"
                  name="gender"
                  value={form.gender || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              ) : (
                <p>{about.gender || "-"}</p>
              )}
            </div>

            {/* City */}
            <div className="col-md-6">
              <label>City</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="city"
                  value={form.city || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.city || "-"}</p>
              )}
            </div>

            {/* Country */}
            <div className="col-md-6">
              <label>Country</label>
              {isEditing ? (
                <input
                  className="form-control"
                  name="country"
                  value={form.country || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.country || "-"}</p>
              )}
            </div>

            {/* Address */}
            <div className="col-12">
              <label>Address</label>
              {isEditing ? (
                <textarea
                  className="form-control"
                  name="address"
                  rows="2"
                  value={form.address || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.address || "-"}</p>
              )}
            </div>

            {/* Bio */}
            <div className="col-12">
              <label>Bio</label>
              {isEditing ? (
                <textarea
                  className="form-control"
                  name="bio"
                  rows="3"
                  value={form.bio || ""}
                  onChange={handleChange}
                />
              ) : (
                <p>{about.bio || "-"}</p>
              )}
            </div>

          </div>

        </div>

      )}

      {/* ================= POSTS TAB ================= */}

      {activeTab === "posts" && (

        <div>

          {posts.length === 0 && (
            <div className="text-center p-4">
              No Posts Available
            </div>
          )}


            <div className="row g-2">

              {posts.map((post) =>
                post.post_images?.map((img, i) => (

                  <div className="col-4" key={`${post.post_id}-${i}`}>

                    <img
                      src={`https://thetalentclub.co.in/upload/post_files/${img}`}
                      alt="post"
                      className="img-fluid"
                      // onClick={() => setSelectedPost(post)}
                       onClick={() => navigate(`/profiledetail/${post.user_id}`)}

                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        cursor: "pointer"
                        
                      }}
                    />

                  </div>

                ))
              )}

            </div>

          

        </div>

      )}

{selectedPost && (
  <div
    className="modal fade show"
    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.7)" }}
  >
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">
            {selectedPost.firstname} {selectedPost.lastname}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setSelectedPost(null)}
          ></button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="row">

            {/* LEFT - IMAGES */}
            <div className="col-md-6">

              {selectedPost.post_images?.map((img, i) => (
                <img
                  key={i}
                  src={`https://thetalentclub.co.in/upload/post_files/${img}`}
                  alt=""
                  className="img-fluid mb-2 rounded"
                />
              ))}

            </div>

            {/* RIGHT - DETAILS */}
            <div className="col-md-6">

              <p><b>Title:</b> {selectedPost.title || "-"}</p>

              <p><b>Description:</b> {selectedPost.description || "-"}</p>

              <p><b>Likes:</b> {selectedPost.like_count || 0}</p>

              <p><b>Date:</b> {selectedPost.createdDate || "-"}</p>

            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
)}
    </div>

  );

};

export default ProfileTabs;